import type { ObfuscatedGameState } from "@presidents/game-engine";
import { MutableRefObject, useLayoutEffect, useRef } from "react";
import { getInvertedTransform } from "../utils/animation";

export default function useInPlayAnimation<E extends HTMLElement | null>(
  containerRef: MutableRefObject<E>,
  gameState: ObfuscatedGameState | undefined
) {
  const lastTurnIdRef = useRef<string | undefined>(undefined);
  useLayoutEffect(() => {
    const turn = gameState?.inPlay;
    if (turn && turn._id !== lastTurnIdRef.current) {
      const cardsSelected = Array.from(
        document.querySelectorAll(
          `[data-owner='${turn.player}'][data-selected]`
        )
      ) as HTMLDivElement[];
      const cardsToPlay = Array.from(
        containerRef.current!.querySelectorAll(".inplay-card")
      ) as HTMLDivElement[];
      if (cardsSelected.length === cardsToPlay?.length) {
        const from: DOMRect[] = [];
        const to: DOMRect[] = [];
        cardsSelected.forEach((card) => {
          from.push(card.getBoundingClientRect());
        });
        cardsToPlay?.forEach((card) => {
          to.push(card.getBoundingClientRect());
        });
        to.forEach((end, idx) => {
          const prev = from[idx];
          if (prev) {
            const card = cardsToPlay[idx];
            const transform = getInvertedTransform(prev, end);
            card.style.transform = transform;
          }
        });
        requestAnimationFrame(() => {
          if (!cardsToPlay.length) {
            console.error("Animation failed!");
          }
          cardsToPlay.forEach((card) => {
            card.style.transition = `transform 0.6s cubic-bezier(0.83, 0, 0.17, 1)`;
            card.style.transform = "";
          });
        });
      }
    }
    lastTurnIdRef.current = turn?._id;
  }, [gameState?._id]);
}
